
import classNames from 'classnames'
import React from 'react'

type InputProps = {
  className?: string
  type?: string
  id?: string
  name?: string
  autoComplete?: string
  placeholder?: string
  onChange?: (_event: React.ChangeEvent<HTMLInputElement>) => void
  value?: string | number
  defaultValue?: string | number
  disabled?: boolean
  ref?: React.Ref<HTMLInputElement>
  maxLength?: number
  min?: number
  max?: number
}

const Input = React.forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const {
    type = 'text',
    value,
    defaultValue,
    placeholder = '',
    onChange,
    className = '',
    name,
    id,
    autoComplete = 'off',
    disabled = false,
    maxLength,
    min,
    max,
  } = props

  return (
    <input
      className={classNames('input-field min-h-[44px]', className)}
      type={type}
      name={name}
      id={id}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      placeholder={placeholder}
      autoComplete={autoComplete}
      disabled={disabled}
      ref={ref}
      maxLength={maxLength}
      min={min}
      max={max}
    />
  )
})

export default Input
